// Given a random string that may contains '<', '>' and '&', returns
// an escaped version that is safe to use as html content
export const htmlEscape = (unsafe: string): string => {
  if (!unsafe || typeof unsafe !== 'string') {
    // Let the caller deal with null/undefined
    return unsafe;
  }

  return unsafe.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
};
